import CatalogAddItem from "./dialog";
import BulkCatalogAddItem from "./bulk-dialog";

export default CatalogAddItem;
export { CatalogAddItem, BulkCatalogAddItem };
